import { Step } from "react-joyride"

export const TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES = "TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES"
export const TUTORIAL_TARGET_MES_DECLARATIONS_BUTTON_CREATE = "TUTORIAL_TARGET_MES_DECLARATIONS_BUTTON_CREATE"
export const TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_FORM = "TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_FORM"
export const TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_SUBMIT_BUTTON = "TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_SUBMIT_BUTTON"
export const TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM = "TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM"
export const TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_EYE_ICON = "TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_EYE_ICON"
export const TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_NAVIGATION_ICONS = "TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_NAVIGATION_ICONS"

export const TUTORIAL_ACTIVITES_STEPS: Step[] = [
     {
          target: `.${TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES}`,
          title: "Mes activités",
          content: "Cet élément du menu vous servira à déclarer votre activité de fin de mois",
          disableBeacon: true,
          placement: "right",
     },
     {
          target: `.${TUTORIAL_TARGET_MES_DECLARATIONS_BUTTON_CREATE}`,
          title: "Créez votre déclaration",
          content: "Ce bouton servira à créer une nouvelle déclaration",
          disableBeacon: true,
          placement: "bottom",
     },
     {
          target: `.${TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_FORM}`,
          title: "Ajoutez votre déclaration",
          content: "Saisissez le mois et l'année pour générer votre déclaration",
          disableBeacon: true,
          placement: "bottom",
     },
     {
          target: `.${TUTORIAL_TARGET_MES_DECLARATIONS_CREATE_SUBMIT_BUTTON}`,
          content: "Puis suivant",
          disableBeacon: true,
          placement: "bottom",
     },
     {
          target: `.${TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM}`,
          title: "Votre nouvelle déclaration",
          content: "Votre déclaration apparaitra ici",
          disableBeacon: true,
          placement: "bottom",
     },
     {
          target: `.${TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_EYE_ICON}`,
          title: "Votre nouvelle déclaration",
          content: "Accédez au détails en utilsant ce bouton",
          disableBeacon: true,
          placement: "bottom",
     },
     {
          target: `.${TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES_LISTING_ITEM_NAVIGATION_ICONS}`,
          title: "Votre nouvelle déclaration",
          content: "Vous pouvez accéder au détails également via ces bouton de navigation",
          disableBeacon: true,
          placement: "bottom",
     },
]
